import React, {PropTypes} from 'react'; 
import classNames from 'classnames';
import ResultsLimited from '../ResultsLimited.jsx';
import ResultsNotFound from '../ResultsNotFound.jsx';
import AuditSearchVirtualEntryContainer from './AuditSearchVirtualEntryContainer.jsx';

const AuditSearchVirtualEntryList = ({
  searchValue,
  onSearchEnterKeyPress,
  onSearchClick,
  onSearchValueChange,
  list,
  exceededResultLimit
}) => ( 
  <div className="animated fadeIn"> 
    <div className="panel panel-primary">
      <div className="panel-heading row">
        <div className="col-sm-12">
          <h4 className="panel-title">{'Search Virtual Entry History'}</h4>
        </div> 
      </div>
      <div className="panel-body">
        <div className="animated fadeIn flex wrap">
          <p className="row col-xs-12">You can search for virtual entries by entry name, entry number, bowler name, or captain name.</p>
          <div className={classNames(
            'input-group input-group-md'
          )} style={{padding: "0px 0px 16px 0px", minWidth: "360px"}}>
            <input type="text"
                autoFocus
                placeholder="Type your search here..."
                className="form-control"
                value={searchValue}
                onChange={event => onSearchValueChange(event.target.value)}
                onKeyDown={onSearchEnterKeyPress}
            />
            <span className="input-group-btn">
              <button className="btn btn-primary"
                      type="button"
                      onClick={onSearchClick}
                      disabled={!searchValue || searchValue.trim().length < 3}>
                      <i className="fa fa-search" /></button>
            </span>
          </div>
          <small className="row col-xs-12">A minimum of three characters are required.</small>
        </div>
        { exceededResultLimit ? <ResultsLimited/> : null }
        { list && list.length == 0 ? <ResultsNotFound/> : null }
        <div className="list-group">
          { list ? list.map((item, index) => (
            <AuditSearchVirtualEntryContainer key={index}   
                       {...item} /> 
            )) : null}
        </div>
      </div>
    </div>
  </div>
);

AuditSearchVirtualEntryList.defaultProps = { 
  searchValue: '',
  exceededResultLimit: false
};

AuditSearchVirtualEntryList.propTypes = { 
  onSearchClick: PropTypes.func,
  onSearchEnterKeyPress: PropTypes.func,
  onSearchValueChange: PropTypes.func,
  searchValue: PropTypes.string,
  exceededResultLimit: PropTypes.bool,
  list: PropTypes.arrayOf(PropTypes.object)
};

export default AuditSearchVirtualEntryList; 


// WEBPACK FOOTER //
// ./src/features/admin/audit/virtualEntryAudit/AuditSearchVirtualEntryList.jsx